"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseConfig = exports.replaceMe = exports.stringArrayEnvParser = exports.integerEnvParser = exports.booleanEnvParser = void 0;
function envOverrideValues(config, path = [], environment = process.env) {
    if (config == null) {
        return {};
    }
    return Object.entries(config).reduce((overrides, [key, value]) => {
        let envValue;
        if (typeof value === 'function') {
            try {
                envValue = value(environment);
            }
            catch (err) {
                throw new Error(`Error handling env var at key ${path.concat(key).join('.')}: ${err}`);
            }
        }
        else if (typeof value === 'string') {
            envValue = environment[value];
        }
        else {
            envValue = envOverrideValues(value, path.concat(key), environment);
        }
        if (envValue == null) {
            return overrides;
        }
        return {
            ...overrides,
            [key]: envValue,
        };
    }, {});
}
const TRUE_ENV_VALUES = ['true', 't', '1'];
const FALSE_ENV_VALUES = ['false', 'f', '0'];
function booleanEnvParser(envKey) {
    return (env) => {
        const envValue = env[envKey];
        if (envValue == null) {
            return;
        }
        const lowerEnvValue = envValue.toLowerCase();
        if (TRUE_ENV_VALUES.includes(lowerEnvValue)) {
            return true;
        }
        if (FALSE_ENV_VALUES.includes(lowerEnvValue)) {
            return false;
        }
        throw new Error(`invalid env value ${envValue} for key ${envKey}, acceptable values are ${TRUE_ENV_VALUES.concat(FALSE_ENV_VALUES).join(',')}`);
    };
}
exports.booleanEnvParser = booleanEnvParser;
function integerEnvParser(envKey) {
    return (env) => {
        const envValue = env[envKey];
        if (envValue == null) {
            return;
        }
        const numberEnvValue = parseInt(envValue, 10);
        if (isNaN(numberEnvValue)) {
            throw new Error(`invalid number ${envValue} for key ${envKey}`);
        }
        return numberEnvValue;
    };
}
exports.integerEnvParser = integerEnvParser;
function stringArrayEnvParser(envKey) {
    return (env) => {
        const envValue = env[envKey];
        if (envValue == null) {
            return;
        }
        return envValue.split(',');
    };
}
exports.stringArrayEnvParser = stringArrayEnvParser;
const INTERNAL_REPLACE_ME = {};
function replaceMe() {
    return INTERNAL_REPLACE_ME;
}
exports.replaceMe = replaceMe;
function checkMissingConfig(defaultConfig, finalValue, path = []) {
    for (const [key, value] of Object.entries(defaultConfig)) {
        const resolvedValue = finalValue[key];
        if (resolvedValue === INTERNAL_REPLACE_ME) {
            throw new Error(`Missing value for key ${path.concat(key).join('.')}`);
        }
        if (typeof value === 'object' && value !== null) {
            checkMissingConfig(value, resolvedValue, path.concat(key));
        }
    }
}
function deepMerge(base, toMerge) {
    return Object.keys(toMerge).reduce((final, key) => {
        let override = toMerge[key];
        if (typeof override === 'object' && !Array.isArray(override)) {
            override = deepMerge(base[key], override);
        }
        return {
            ...final,
            [key]: override,
        };
    }, base);
}
function parseConfig(defaultConfig, localConfig, envOverrides, environment) {
    let finalConfig = defaultConfig;
    if (localConfig != null) {
        finalConfig = deepMerge(finalConfig, localConfig);
    }
    if (envOverrides != null) {
        finalConfig = deepMerge(finalConfig, envOverrideValues(envOverrides, undefined, environment));
    }
    checkMissingConfig(defaultConfig, finalConfig);
    return finalConfig;
}
exports.parseConfig = parseConfig;
//# sourceMappingURL=index.js.map